import { useEffect, useRef, useState, type ReactNode } from 'react'

/** Reserve the media box, but let only an on-screen demo own downloadable assets. */
export default function VisibleMedia({ children, className }: { children: ReactNode; className: string }) {
  const ref = useRef<HTMLDivElement>(null)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const element = ref.current
    if (!element) return
    const observer = new IntersectionObserver(([entry]) => setVisible(entry.isIntersecting))
    observer.observe(element)
    return () => observer.disconnect()
  }, [])

  return <div ref={ref} className={className}>{visible ? children : null}</div>
}
